import { Paper, TableContainer } from '@mui/material';
import FetPatientsTable from './FET/FetPatientsTable';
import FetThawingTable from './FET/FetThawingTable';
import FetEmbryoTable from './FET/FetEmbryoTable';
import FetPregnancyTable from './FET/FetPregnancyTable';

function FetCyclesTable() {
  return (
    <TableContainer component={Paper} style={{ display: 'flex' }}>
      <FetPatientsTable />
      <FetThawingTable />
      <FetEmbryoTable />
      <FetPregnancyTable />
    </TableContainer>
  );
}

export default FetCyclesTable;
